import { BadgeField, FieldProps, useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';

interface ContractCategoryFieldProps extends FieldProps {}

const ContractCategoryField = (props: ContractCategoryFieldProps) => {
  const { getValue } = useFieldHelper(props);
  const isPrimary = !getValue();

  return (
    <BadgeField
      badges={[
        <CustomBadge color="success" isVisible={isPrimary} text="Primary" />,
        <CustomBadge color="secondary" isVisible={!isPrimary} text="Secondary" />,
      ]}
      width={100}
      {...props}
    />
  );
};

export default ContractCategoryField;
